<template>
  <v-layout align-start>
    <v-flex v-show="rol == 'ADM' || rol == 'NOM'">
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchParamCodigo"
                append-icon="search"
                label="Búsqueda por código"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchParamDescripcion"
                append-icon="search"
                label="Búsqueda por descripción"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6" md="6">
              <v-toolbar-title class="font-weight-black primary--text"
                >Cambios de Personal</v-toolbar-title
              >
            </v-col>
          </v-row>

          <v-spacer></v-spacer>

          <v-menu :rounded="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large color="primary" v-bind="attrs" v-on="on" dark>
                <v-icon dark>fa-solid fa-cloud-arrow-up </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="mostrarCarga">
                <v-list-item-title
                  >Carga para Análisis de Variación</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarDialogExcel"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> fa-solid fa-file-excel </v-icon>
              </v-btn>
            </template>
            <span>Generar Reportes</span>
          </v-tooltip>
        </v-app-bar>
        <v-sheet
          class="overflow-y-auto"
          :max-height="windowHeigth + this.auxHeigth"
        >
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - 150 + auxHeigth"
            :headers="headers"
            :items="dtCambios"
            :items-per-page="2"
            sort-by="codigo"
            class="elevation-1"
            :loading="dtCambiosLoad"
            loading-text="Cargando... Espere por favor"
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'items-per-page-options': [100, 150, 200, -1],
            }"
          >
            <template v-slot:[`item.opciones`]="{ item }">
              <v-btn x-small text dark color="primary" @click="editar(item)">
                <v-icon x-small>edit</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'I'">
                <v-btn
                  color="error"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="listar">Cargar</v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogCargaExcel" max-width="40%">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga Masiva de Datos</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCarga"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="attach_file"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="guardarExcel"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogActivacion" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogActivacion = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogExcel" persistent max-width="500">
        <v-card>
          <v-card-title>Generación de Reportes</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-autocomplete
                  outlined
                  dense
                  ref="reporte"
                  v-model="reporte"
                  :items="reportesList"
                  :rules="[$rules.requerido]"
                  :error-messages="errorMessages"
                  label="Reporte"
                  item-text="descripcion"
                  item-value="id"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-show="reporte > 1">
                <v-autocomplete
                  outlined
                  dense
                  chips
                  deletable-chips
                  multiple
                  ref="mes"
                  v-model="mes"
                  :items="mesesList"
                  :rules="[]"
                  hint="Si se deja en blanco, se eligen todos los meses"
                  persistent-hint
                  :error-messages="errorMessages"
                  item-text="descripcion"
                  item-value="id"
                  label="Mes"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-show="reporte > 2">
                <v-autocomplete
                  outlined
                  dense
                  chips
                  deletable-chips
                  multiple
                  ref="clasificacion_a"
                  v-model="clasificacion_a"
                  :items="clasificacionList"
                  :rules="[]"
                  :error-messages="errorMessages"
                  hint="Si se deja en blanco, se eligen todas las categorías"
                  persistent-hint
                  item-text="descripcion"
                  item-value="id"
                  label="Categoria"
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogExcel = false">Cancelar</v-btn>
            <v-btn
              color="primary"
              text
              @click="GenerarReporteExcel()"
              :loading="load"
              >Generar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogForm" max-width="500px" persistent>
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  :class="porcentajeCco === 100 ? 'd-none' : ''"
                >
                  <v-alert text outlined color="error" icon="warning">
                    No se ha asignado el 100% en Centros de Costo para el Cargo
                    seleccionado.
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="codigo"
                    v-model="codigo"
                    :readonly="!editarCodigo"
                    :rules="[$rules.requerido, $rules.max10]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Código"
                    placeholder="Código"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="descripcion"
                    v-model="descripcion"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    :rules="[$rules.requerido, $rules.max50, $rules.min2]"
                    :error-messages="errorMessages"
                    label="Descripción"
                    placeholder="Descripción"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_area"
                    v-model="id_area"
                    :items="areaList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    @change="selectSubarea"
                    item-text="descripcion"
                    item-value="id"
                    label="Área"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_subarea"
                    v-model="id_subarea"
                    :items="subareaList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Subárea"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_area_presupuesto"
                    v-model="id_area_presupuesto"
                    :items="areaPresupList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Area Presupuesto"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    reverse
                    dense
                    ref="salario_ref"
                    v-model="salario_ref"
                    :rules="[$rules.numero]"
                    :error-messages="errorMessages"
                    label="Salario Referencial"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-show="esEditado">
                <v-card class="overflow-hidden">
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <v-row v-if="mostrarBusquedas">
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          class="text-xs-center"
                          v-model="searchParamCodigo"
                          append-icon="search"
                          label="Búsqueda por código"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          class="text-xs-center"
                          v-model="searchParamDescripcion"
                          append-icon="search"
                          label="Búsqueda por descripción"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="agregarCentroCosto"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> add </v-icon>
                        </v-btn>
                      </template>
                      <span>Ingresar nuevo registro</span>
                    </v-tooltip>
                  </v-app-bar>
                  <v-sheet class="overflow-y-auto" :max-height="400">
                    <v-data-table
                      dense
                      fixed-header
                      :height="200"
                      :headers="headersCentroCosto"
                      :items="dtCentroCostos"
                      mobile-breakpoint="0"
                      :items-per-page="50"
                      sort-by="codigo"
                      class="elevation-1"
                      :loading="!dtCentroCostos.length"
                      loading-text="Cargando... Espere por favor"
                      :hide-default-footer="true"
                    >
                      <template v-slot:[`item.opciones`]="{ item }">
                        <v-btn
                          text
                          x-small
                          dark
                          color="primary"
                          @click="deleteItemCentroCosto(item)"
                        >
                          <v-icon x-small>delete</v-icon>
                        </v-btn>
                      </template>

                      <template v-slot:[`item.estado`]="{ item }">
                        <div v-if="item.estado == 'I'">
                          <v-btn
                            color="error"
                            x-small
                            text
                            dark
                            @click="abrirDialogActivacion(item)"
                          >
                            <v-icon x-small>block</v-icon>
                          </v-btn>
                        </div>
                        <div v-else>
                          <v-btn
                            color="success"
                            x-small
                            text
                            dark
                            @click="abrirDialogActivacion(item)"
                          >
                            <v-icon x-small>check</v-icon>
                          </v-btn>
                        </div>
                      </template>

                      <template v-slot:no-data>
                        <v-btn color="primary" @click="listarCargoCentro"
                          >Reset</v-btn
                        >
                      </template>
                    </v-data-table>
                  </v-sheet>
                </v-card>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cerrar">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogUpload" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline"
              >Carga Masiva para Análisis de Variación</span
            >
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="fa-solid fa-file-excel"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessagesUpload"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Cargar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog dense v-model="dialogCentroCosto" max-width="500px">
        <v-card ref="formCentroCosto">
          <v-card-title>
            <span class="headline">Datos Centro de Costo</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_centro_costo"
                    v-model="id_centro_costo"
                    :items="CentroCostosList"
                    :readonly="editedIndexCco"
                    :rules="[]"
                    :error-messages="errorMessagesCentroCosto"
                    item-text="descripcion"
                    item-value="id"
                    label="Centro de Costo"
                    required
                  ></v-autocomplete>

                  <v-text-field
                    outlined
                    dense
                    ref="porcentaje"
                    v-model="porcentaje"
                    :rules="[$rules.numero, $rules.requerido]"
                    :error-messages="errorMessagesCentroCosto"
                    label="Porcentaje"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeCentroCosto"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="guardarCentroCosto"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogBorrarCentroCosto" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción borrará la asignación de Centro de Costo al
            cargo.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBorrarCentroCosto = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" text @click="eliminarCentroCosto()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";

export default {
  data() {
    return {
      //Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      rol: this.$store.state.usuario.rol,
      //Declaración de arrays
      dtCambios: [],
      dtCambiosLoad: true,
      dtCentroCostos: [],
      areaList: [],
      subareaList: [],
      areaPresupList: [],
      CentroCostosList: [],
      reportesList: [
        { id: 1, descripcion: "Descargar base de Reportes" },
        { id: 2, descripcion: "Reporte de Análisis de Variación" },
        { id: 3, descripcion: "Reporte de Análisis por Clasificación" },
      ],
      mesesList: [
        { id: 1, descripcion: "Enero" },
        { id: 2, descripcion: "Febrero" },
        { id: 3, descripcion: "Marzo" },
        { id: 4, descripcion: "Abril" },
        { id: 5, descripcion: "Mayo" },
        { id: 6, descripcion: "Junio" },
        { id: 7, descripcion: "Julio" },
        { id: 8, descripcion: "Agosto" },
        { id: 9, descripcion: "Septiembre" },
        { id: 10, descripcion: "Octubre" },
        { id: 11, descripcion: "Noviembre" },
        { id: 12, descripcion: "Diciembre" },
      ],
      clasificacionList: [],
      //Declaración de variables de Dialog
      dialogForm: false,
      dialogCargaExcel: false,
      dialogActivacion: false,
      dialogCentroCosto: false,
      dialogBorrarCentroCosto: false,
      dialogUpload: false,
      dialogExcel: false,
      //Declaración de variables de formulario
      id: "",
      codigo: "",
      descripcion: "",
      salario_ref: "",
      id_area: "",
      id_subarea: "",
      id_area_presupuesto: "",
      estado: "",
      porcentajeCco: "",
      porcentaje: 100,
      id_centro_costo: "",
      clasificacion_a: "",
      mes: "",
      reporte: "",
      load: false,
      file: null,
      //Declaración de variables de tabla
      headers: [
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Nombre",
          value: "nombre_completo",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Clasificación A",
          value: "clasificacion_a",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Clasificación B",
          value: "clasificacion_b",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Clasificación C",
          value: "clasificacion_c",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },

        {
          text: "Año",
          value: "anio",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Mes",
          value: "mes",
          align: "left",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "Monto",
          value: "monto",
          align: "right",
          class: "primary white--text text-subtitle-3",
        },
      ],

      headersCentroCosto: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro de Costo",
          value: "codigo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "centro_costo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Porcentaje",
          value: "porcentaje",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
      ],
      searchParamCodigo: "",
      searchParamDescripcion: "",
      esEditado: false,
      editarCodigo: false,
      editarCodigoCentroCosto: false,
      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,
      mostrarBusquedas: false,
      //variables de errrores
      valida: 0,
      errorMessages: "",
      errorMessagesUpload: "",
      errorMessagesCentroCosto: "",
      error: "",
      //variables de tamaño de pantalla

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight + this.auxHeigth,
      auxWidth: 0,
      auxHeigth: 0,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        salario_ref: this.salario_ref,
        id_area: this.id_area,
        id_subarea: this.id_subarea,
        id_area_presupuesto: this.id_area_presupuesto,
      };
    },
    formCentroCosto() {
      return {
        id_centro_costo: this.id_centro_costo,
        porcentaje: this.porcentaje,
      };
    },
  },

  watch: {
    dialogForm(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
      this.errorMessagesCentroCosto = "";
      this.errorMessagesUpload = "";
    },
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.$store.dispatch("actualizarTitulo", "Cambios de Personal");
    this.listar();
    this.selectClasificacionA();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    listar() {
      let me = this;
      me.dtCambiosLoad = true;
      axios
        .get("api/log_cambios_personales/listar")
        .then(function (response) {
          me.dtCambios = response.data;

          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight + me.auxHeigth;
          me.dtCambiosLoad = false;
        })
        .catch(function (error) {
          me.dtCambiosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarCargoCentro() {
      let me = this;
      axios
        .get("api/cargo_centros/listarCargoCentro/" + this.id)
        .then(function (response) {
          me.mostrarPorcentaje();
          me.dtCentroCostos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarCarga() {
      this.dialogUpload = true;
    },
    mostrarPorcentaje() {
      let me = this;
      axios
        .get("api/cargo_centros/mostarPorcentaje/" + this.id)
        .then(function (response) {
          me.porcentajeCco = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectSubarea() {
      let me = this;
      axios
        .get("api/subareas/select/" + this.id_area)
        .then(function (response) {
          me.subareaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectClasificacionA() {
      let me = this;
      axios
        .get("api/log_cambios_personales/selectClasificacionA")
        .then(function (response) {
          me.clasificacionList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCentroCosto() {
      let me = this;
      axios
        .get("api/centro_costos/select")
        .then(function (response) {
          me.CentroCostosList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listar();
    },

    abrirDialogActivacion(item) {
      this.id = item.id;
      this.dialogActivacion = true;
      this.estado = item.estado;
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
      this.windowWidth = window.innerWidth;
      this.windowHeigth = window.innerHeight;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    cerrarCarga() {
      this.dialogCargaExcel = false;
      this.limpiarCargaExcel();
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },
    closeCentroCosto() {
      this.dialogCentroCosto = false;
      this.limpiarCentroCosto();
    },
    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },
    editar(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.salario_ref = item.salario_ref;
      this.id_area = item.id_area;
      this.id_subarea = item.id_subarea;
      this.id_area_presupuesto = item.id_area_presupuesto;
      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogForm = true;
      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada

      this.selectSubarea();
      this.listarCargoCentro();
    },
    agregar() {
      this.editarCodigo = true;
      this.dialogForm = true;
    },
    agregarCentroCosto() {
      this.editarCodigoCentroCosto = true;
      this.dialogCentroCosto = true;
    },

    cerrar() {
      this.dialogForm = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.salario_ref = "";
      this.id_area = "";
      this.id_subarea = "";
      this.id_area_presupuesto = "";
      this.esEditado = false;
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    limpiarCentroCosto(item) {
      this.id_centro_costo = "";
      this.id_cargo = "";
      this.porcentaje = 100;
      this.editedIndexCco = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.esEditado) {
        //codigo para editar
        let me = this;
        axios
          .put("api/Log_cambios_personales/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,
            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/Log_cambios_personales/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,
            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    exportarExcel() {
      let me = this;
      try {
        json2excel({
          data: me.dtCambios,
          name: "Cargos",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    mostrarDialogExcel() {
      this.dialogExcel = true;
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/log_cambios_personales/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarCentroCosto() {
      this.validaCentroCosto = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formCentroCosto).forEach((f) => {
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaCentroCosto += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaCentroCosto += 1;
        }
      });
      return this.validaCentroCosto;
    },

    activar() {
      let me = this;
      axios
        .put(
          "api/Log_cambios_personales/activar/" + me.id + "/" + me.usuario,
          {}
        )
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar() {
      let me = this;
      axios
        .put(
          "api/Log_cambios_personales/desactivar/" + me.id + "/" + me.usuario,
          {}
        )
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteItemCentroCosto(item) {
      this.id_centro_costo = item.id_centro_costo;
      this.dialogBorrarCentroCosto = true;
    },
    eliminarCentroCosto() {
      let me = this;

      axios
        .delete(
          "api/cargo_centros/EliminarCargoCentro/" +
            me.id +
            "/" +
            me.id_centro_costo,
          {}
        )
        .then(function (response) {
          me.listarCargoCentro();
          me.$store.dispatch("setSnackbar", {
            text: "Centro de Costo eliminado exitosamente.",
            color: "success",
          });
          me.dialogBorrarCentroCosto = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardarCentroCosto() {
      if (this.validarCentroCosto() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexCco) {
        let me = this;
        axios
          .put("api/cargo_centros/actualizar", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoCentro();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/cargo_centros/crear", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoCentro();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    GenerarReporteExcel() {
      let me = this;
      me.load = true;
      var mesAux = this.mes;
      var clasifAux = this.clasificacion_a;
      mesAux =
        this.mes == null || this.mes == undefined || this.mes == ""
          ? "0"
          : this.mes;
      clasifAux =
        this.clasificacion_a == null ||
        this.clasificacion_a == undefined ||
        this.clasificacion_a == ""
          ? "0"
          : this.clasificacion_a;
      var urlAux =
        this.reporte == 1
          ? "api/Log_cambios_personales/ExportarExcelReporteBase"
          : this.reporte == 2
          ? "api/log_cambios_personales/ExportarExcelReporteA/" + mesAux
          : "api/Log_cambios_personales/ExportarExcelReporteB/" +
            mesAux +
            "/" +
            clasifAux;

      var nombreArchivo =
        this.reporte == 1
          ? "BaseAnalisis"
          : this.reporte == 2
          ? "AnalisisVariacion"
          : "AnalisisCategoria";
      axios({
        url: urlAux,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          nombreArchivo + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
        me.dialogExcel = false;
      });
    },

    filtroCodigo(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamCodigo) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value.toLowerCase().includes(this.searchParamCodigo.toLowerCase());
    },
    filtroDescripcion(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamDescripcion) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value
        .toLowerCase()
        .includes(this.searchParamDescripcion.toLowerCase());
    },
  },
};
</script>
